import React from 'react';
import { CardCollection, VerticalListing, Link, MaskedLink } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import formatPrice from '../../../utils/formatPrice';

import Classes from './EvipSimilarItems.scss';
import { TSimilarItemsClient } from 'types/TSimilarItems';

type TEvipSimilarItemsProps = {
  eVipSimilarItems: TSimilarItemsClient[];
};

const EvipSimilarItems = ({ eVipSimilarItems }: TEvipSimilarItemsProps) => {
  const { t } = useI18nContext();

  return (
    <div className={Classes.root}>
      <h1 className={Classes.title}>{t('expired.similarItems')}</h1>
      <CardCollection kind="grid" className={Classes.similarItems}>
        {eVipSimilarItems.map((item) => {
          const { location, imageUrl = '', price, key, title, url, thinContent } = item;
          const LinkComponent = thinContent ? MaskedLink : Link;
          return (
            <LinkComponent href={url} key={key} kind="block">
              <VerticalListing
                imageSrc={imageUrl}
                imageLoading="lazy"
                price={formatPrice(price, t)}
                title={title}
                location={location?.cityName}
              />
            </LinkComponent>
          );
        })}
      </CardCollection>
    </div>
  );
};

export default EvipSimilarItems;
